<template>
	<b-container class="print-page" id="print-page-1">
		<b-row>
			<b-col>
				<div class="media">
					<character-image :src="Character.Bio.Image" />
					<div class="media-body align-items-start">
						<heading/>
						<hr />
						<div class="row">
							<block-ability-scores/>
							<block-saves/>
							<block-health-resolve/>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
		<hr />
		<b-row>
			<b-col cols="5">
				<!--Left Column-->

				<block-initiative/>
				<block-skills/>
				<block-armor/>
			</b-col>

			<b-col cols="7">
				<!--Right Column-->
				<block-abilities/>
				<block-attacks/>
				<block-weapons/>
				
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
let components = {}

components.Heading = () => import('@/components/print/Heading.vue')
components.CharacterImage = () => import('@/components/print/CharacterImage.vue')
components.BlockAbilityScores = () => import('@/components/print/block/AbilityScores.vue')
components.BlockSaves = () => import('@/components/print/block/Saves.vue')
components.BlockHealthResolve = () => import('@/components/print/block/HealthResolve.vue')
components.BlockInitiative = () => import('@/components/print/block/Initiative.vue')
components.BlockSkills = () => import('@/components/print/block/Skills.vue')
components.BlockArmor = () => import('@/components/print/block/Armor.vue')
components.BlockAttacks = () => import('@/components/print/block/Attacks.vue')
components.BlockAbilities = () => import('@/components/print/block/Abilities.vue')
components.BlockWeapons = () => import('@/components/print/block/Weapons.vue')

export default {
	components,
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>